export default "__VITE_ASSET__DG2XMj7o__"